export const environment = 
{
    production: true,
    // API_URL: 'https://demo.linuxmantra.com/amd',
    API_URL: 'https://gilpinonline.com',
    hdfcUrl:'https://secure.ccavenue.com',

    aws: {
        region: 'ap-south-1',
        cognito: {
          userPoolId: 'ap-south-1_Mfvw09j8e',
          userPoolWebClientId: '5qojdls82ql3rf6ma7fvt8gh84',
        },
      },
};